import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// --- MÜFREDAT VERİSİ ---
const curriculumData = [
  {
    id: 1,
    name: '1. Mevsimler ve İklim',
    topics: [
      {
        id: 1,
        name: 'Mevsimlerin Oluşumu',
        summary: 'Dünya\'nın eksen eğikliği ve Güneş etrafındaki dolanma hareketinin mevsimleri nasıl oluşturduğunu keşfedin.',
      },
      {
        id: 2,
        name: 'İklim ve Hava Hareketleri',
        summary: 'İklim ile hava olayları arasındaki farkları, rüzgar oluşumunu ve küresel iklim değişikliklerini inceleyin.',
      },
    ],
  },
  {
    id: 2,
    name: '2. DNA ve Genetik Kod',
    topics: [
      {
        id: 1,
        name: 'DNA ve Genetik Kod',
        summary: 'Hücrenin yönetici molekülü DNA\'nın yapısını, eşlenmesini ve genetik kodun şifrelerini çözün.',
      },
      {
        id: 2,
        name: 'Kalıtım',
        summary: 'Anne ve babadan gelen özelliklerin yavrulara nasıl aktarıldığını ve Mendel\'in bezelye deneylerini keşfedin.',
      },
      {
        id: 3,
        name: 'Mutasyon ve Modifikasyon',
        summary: 'Genlerdeki ani değişimler (mutasyon) ile çevre etkisiyle oluşan geçici değişimler (modifikasyon) arasındaki farkları öğrenin.',
      },
      {
        id: 4,
        name: 'Adaptasyon',
        summary: 'Canlıların yaşadıkları çevreye uyum sağlayarak hayatta kalma şanslarını artıran özelliklerini inceleyin.',
      },
      {
        id: 5,
        name: 'Biyoteknoloji',
        summary: 'Genetik mühendisliği ve biyoteknolojinin insanlık için yararlarını, zararlarını ve uygulama alanlarını keşfedin.',
      },
    ],
  },
  {
    id: 3,
    name: '3. Basınç',
    topics: [
      {
        id: 1,
        name: 'Katı Basıncı',
        summary: 'Katıların uyguladıkları kuvvetin yüzeye etkisini ve basıncı değiştiren faktörleri günlük hayat örnekleriyle inceleyin.',
      },
      {
        id: 2,
        name: 'Sıvı Basıncı',
        summary: 'Derinlik ve yoğunluğun sıvı basıncına etkisini ve Pascal Prensibi\'nin teknolojideki uygulamalarını keşfedin.',
      },
      {
        id: 3,
        name: 'Gaz Basıncı',
        summary: 'Açık hava basıncının etkilerini, Torricelli deneyini ve gazların basınç özelliklerini öğrenin.',
      },
    ],
  },
  {
    id: 4,
    name: '4. Madde ve Endüstri',
    topics: [
      {
        id: 1,
        name: 'Periyodik Sistem',
        summary: 'Elementlerin sınıflandırılmasını, metal, ametal ve yarı metallerin özelliklerini periyodik tablo üzerinde keşfedin.',
      },
      {
        id: 2,
        name: 'Fiziksel ve Kimyasal Değişimler',
        summary: 'Maddenin sadece dış görünüşünü değiştiren fiziksel değişimler ile yapısını değiştiren kimyasal değişimleri ayırt edin.',
      },
      {
        id: 3,
        name: 'Kimyasal Tepkimeler',
        summary: 'Atomların bağ yapısını değiştirerek yeni maddelere dönüştüğü kimyasal tepkimeleri ve kütlenin korunumu yasasını keşfedin.',
      },
      {
        id: 4,
        name: 'Asitler ve Bazlar',
        summary: 'Asit ve bazların özelliklerini, pH kavramını, günlük hayattaki yerlerini ve asit yağmurlarının etkilerini keşfedin.',
      },
      {
        id: 5,
        name: 'Maddenin Isı ile Etkileşimi',
        summary: 'Isı, sıcaklık ve öz ısı kavramlarını, hal değişim süreçlerini ve ısınma-soğuma grafiklerini yorumlamayı keşfedin.',
      },
      {
        id: 6,
        name: 'Türkiye\'de Kimya Endüstrisi',
        summary: 'Türkiye\'deki kimya endüstrisinin gelişimini, ithalat-ihracat ürünlerini ve ilgili meslek dallarını inceleyin.',
      },
    ],
  },
  {
    id: 5,
    name: '5. Basit Makineler',
    topics: [
      {
        id: 1,
        name: 'Basit Makineler',
        summary: 'İş yapma kolaylığı sağlayan makaralar, kaldıraçlar, eğik düzlem ve çıkrık gibi sistemlerin çalışma prensiplerini keşfedin.',
      },
    ],
  },
  {
    id: 6,
    name: '6. Enerji Dönüşümleri ve Çevre',
    topics: [
      {
        id: 1,
        name: 'Besin Zinciri ve Enerji Akışı',
        summary: 'Canlılar arasındaki beslenme ilişkilerini, besin zincirlerini, ekoloji piramidini ve enerji akışını keşfedin.',
      },
      {
        id: 2,
        name: 'Enerji Dönüşümleri',
        summary: 'Bitkilerin güneş ışığını besine dönüştürdüğü fotosentezi ve canlıların enerji üretmek için yaptığı solunum çeşitlerini keşfedin.',
      },
      {
        id: 3,
        name: 'Madde Döngüleri ve Çevre Sorunları',
        summary: 'Su, karbon ve azot döngülerini, küresel ısınmayı, sera etkisini ve ekolojik ayak izi kavramını inceleyin.',
      },
      {
        id: 4,
        name: 'Sürdürülebilir Kalkınma',
        summary: 'Kaynakların tasarruflu kullanımını, geri dönüşümün önemini ve sürdürülebilir yaşam için yapılması gerekenleri keşfedin.',
      },
    ],
  },
  {
    id: 7,
    name: '7. Elektrik Yükleri ve Enerjisi',
    topics: [
      {
        id: 1,
        name: 'Elektrik Yükleri ve Elektriklenme',
        summary: 'Statik elektriği, yüklerin birbirini itip çekmesini ve teknolojideki elektriklenme uygulamalarını keşfedin.',
      },
      {
        id: 2,
        name: 'Elektrik Yüklü Cisimler',
        summary: 'Cisimlerin yük durumlarını, elektroskopu, topraklamayı ve yıldırım-şimşek olaylarını inceleyin.',
      },
      {
        id: 3,
        name: 'Elektrik Enerjisinin Dönüşümü',
        summary: 'Elektrik enerjisinin ısı, ışık ve harekete dönüşümünü, güç santrallerini ve enerji tasarrufunun önemini keşfedin.',
      },
    ],
  },
];

// --- 1. GARANTİ BİLİM VERİSİ (30 Adet) ---
const scienceTriviaData = [
  { id: 1, question: "Uzayda ağlarsan ne olur?", answer: "Gözyaşların akmaz, birikir!", detail: "Yerçekimi olmadığı için gözyaşları yanaklarından süzülmez. Bunun yerine gözünün etrafında su topu gibi toplanır." },
  { id: 2, question: "Ahtapotların kaç kalbi vardır?", answer: "Tam 3 tane kalbi vardır!", detail: "Biri vücuda kan pompalar, diğer ikisi ise solungaçlara kan gönderir. Kanları mavidir." },
  { id: 3, question: "Muzlar neden radyasyon yayar?", answer: "Çünkü potasyum içerirler!", detail: "Muzlar doğal olarak radyoaktif Potasyum-40 izotopu içerir. Ama zarar görmek için 10 milyon tane yemen gerekir!" },
  { id: 4, question: "Venüs'te bir gün ne kadar sürer?", answer: "Bir yıldan daha uzundur!", detail: "Venüs kendi etrafında o kadar yavaş döner ki, Güneş etrafındaki turunu (yıl) tamamlaması, kendi turundan (gün) kısa sürer." },
  { id: 5, question: "İnsan DNA'sı ne kadar uzundur?", answer: "Güneş'e 600 kez gidip gelebilir!", detail: "Vücudundaki tüm hücrelerin DNA'sını uca ekleseydin, uzunluğu Güneş ile Dünya arasındaki mesafenin yüzlerce katı olurdu." },
  { id: 6, question: "Zürafaların ses telleri var mıdır?", answer: "Hayır, ses telleri yoktur!", detail: "Zürafalar ses telleri olmadığı için 'sessiz' sanılır ama aslında çok düşük frekanslı seslerle iletişim kurarlar." },
  { id: 7, question: "Sıcak su mu soğuk su mu çabuk donar?", answer: "Sıcak su daha hızlı donabilir!", detail: "Buna 'Mpemba Etkisi' denir. Belirli koşullarda sıcak su, soğuk sudan daha hızlı buza dönüşür." },
  { id: 8, question: "Eyfel Kulesi yazın uzar mı?", answer: "Evet, 15 cm uzar!", detail: "Yazın sıcaklık arttığında demir genleşir. Bu yüzden kule yaz aylarında kışa göre daha uzundur." },
  { id: 9, question: "Bal bozulur mu?", answer: "Asla bozulmaz!", detail: "Arkeologlar 3000 yıllık yenebilir bal bulmuşlardır. Balın kimyası bakterilerin yaşamasına izin vermez." },
  { id: 10, question: "Köpekbalıkları ağaçlardan yaşlı mı?", answer: "Evet, çok daha yaşlılar!", detail: "Köpekbalıkları 400 milyon yıldır dünyadadır. Ağaçlar ise yaklaşık 350 milyon yıl önce ortaya çıkmıştır." },
  { id: 11, question: "Bir bulut ne kadar ağırdır?", answer: "100 fil ağırlığındadır!", detail: "Ortalama bir kümülüs bulutu 500.000 kg gelebilir. Yoğunluğu havadan az olduğu için düşmez." },
  { id: 12, question: "En güçlü kas hangisidir?", answer: "Çene kası (Masseter)!", detail: "Ağırlığına oranla en güçlü kas çene kasıdır. 90 kilogramlık bir kuvvet uygulayabilir." },
  { id: 13, question: "Işık Güneş'ten bize ne zaman ulaşır?", answer: "8 dakika 20 saniyede.", detail: "Güneş şu an yok olsa, bunu ancak 8 dakika sonra fark edebiliriz." },
  { id: 14, question: "Periyodik tabloda hangi harf yoktur?", answer: "J harfi yoktur!", detail: "Element sembollerinde J harfi kullanılmaz." },
  { id: 15, question: "Çilek meyve midir?", answer: "Teknik olarak değildir!", detail: "Çekirdekleri dışarıda olduğu için botanik olarak 'yalancı meyve' sınıfına girer." },
  { id: 16, question: "Mars'ta gün batımı ne renktir?", answer: "Mavidir!", detail: "Dünya'nın aksine, Mars'ın ince atmosferi gün batımının mavi görünmesine neden olur." },
  { id: 17, question: "Kutup ayıları ne renktir?", answer: "Derileri siyahtır!", detail: "Tüyleri şeffaftır, ışığı yansıttığı için beyaz görünür. Isıyı emmek için derileri siyahtır." },
  { id: 18, question: "Cam sıvı mıdır?", answer: "Amorf katıdır.", detail: "Ne tam katı ne tam sıvıdır. Atomları düzensizdir ama katı gibi davranır." },
  { id: 19, question: "Uzay kokar mı?", answer: "Yanık et gibi kokar!", detail: "Astronotlar uzay kıyafetlerinde yanık metal veya barut benzeri bir koku olduğunu söylerler." },
  { id: 20, question: "Miden kendini sindirir mi?", answer: "Sürekli yeniler!", detail: "Mide asidi metali bile eritebilir. Mide kendini korumak için iç tabakasını sürekli yeniler." },
  { id: 21, question: "Günde kaç kez nefes alırız?", answer: "Yaklaşık 20.000 kez!", detail: "Yetişkin bir insan günde ortalama 20-25 bin kez nefes alır." },
  { id: 22, question: "En büyük canlı nedir?", answer: "Bir mantardır!", detail: "Mavi balina değil! Oregon'daki bir mantar yer altında 9 km² alana yayılmıştır." },
  { id: 23, question: "Elmas neyden yapılır?", answer: "Sadece Karbon'dan!", detail: "Kömür ve elmas aynı atomdan oluşur. Basınç farkı kömürü elmasa dönüştürür." },
  { id: 24, question: "Kelebekler nasıl tat alır?", answer: "Ayaklarıyla!", detail: "Tat alma sensörleri ayaklarındadır, üzerine kondukları çiçeğin tadını böyle alırlar." },
  { id: 25, question: "Sessiz harf içeren sayı?", answer: "Sayıların çoğu!", detail: "İngilizcede 1 milyara kadar hiçbir sayıda 'b' harfi yoktur mesela." },
  { id: 26, question: "Nötron yıldızı ne kadar ağırdır?", answer: "Bir kaşığı Everest kadar!", detail: "O kadar yoğundur ki, bir çay kaşığı maddesi bir dağ ağırlığındadır." },
  { id: 27, question: "Beyin kaç watt yakar?", answer: "Bir ampul kadar (20W).", detail: "Vücudun enerjisinin %20'sini harcasa da sadece loş bir ampulü yakacak güçtedir." },
  { id: 28, question: "Dünya'nın içi ne kadar sıcaktır?", answer: "Güneş yüzeyi kadar!", detail: "Çekirdek sıcaklığı yaklaşık 6000°C'dir." },
  { id: 29, question: "Kar taneleri aynı mıdır?", answer: "Hiçbiri aynı değildir!", detail: "Olasılıklar o kadar fazladır ki tıpatıp aynı iki kar tanesi bulmak imkansızdır." },
  { id: 30, question: "Hapşırmayı tutarsan ne olur?", answer: "Damarların çatlayabilir!", detail: "Basınç içeri hapsolur, kulak zarına zarar verebilir. Tutma, hapşır gitsin!" }
];

// --- 2. YENİ GARANTİ MOTİVASYON VERİSİ (30 Adet) ---
const motivationData = [
  { q: "Başarının sırrı nedir?", a: "Vazgeçmemek.", d: "Yetenek maç kazandırır ama zeka ve takım oyunu şampiyonluk." },
  { q: "Hata yapmaktan korkma!", a: "En iyi öğretmen hatadır.", d: "Bir şeyi hiç hata yapmadan başaran insan, aslında yeni bir şey denememiştir." },
  { q: "Bugün ne yapmalısın?", a: "Dünden daha iyi ol.", d: "Rakiplerinle değil, kendinle yarış. Her gün %1 daha iyi olsan yeter." },
  { q: "En uzun yolculuklar...", a: "Tek bir adımla başlar.", d: "Gözünde büyütme, sadece başla. Gerisi gelecektir." },
  { q: "Mermeri delen su mudur?", a: "Sürekliliğidir!", d: "Suyun gücü değil, damlaların sürekliliği taşı deler. Düzenli çalışmak işte budur." },
  { q: "Yorgun olduğunda durma.", a: "Bitirdiğinde dur.", d: "Pes etmek üzereyken neden başladığını hatırla." },
  { q: "Rüzgarı yönlendiremezsin.", a: "Yelkenleri ayarla.", d: "Şartları değiştiremeyebilirsin ama onlara nasıl tepki vereceğin senin elinde." },
  { q: "Sınav zeka testi mi?", a: "Hayır, çalışma testidir.", d: "LGS zekanı değil, ne kadar disiplinli çalıştığını ölçer." },
  { q: "Rakibin kim?", a: "Dünkü sen.", d: "Başkalarıyla değil, kendinle yarış. Her gün dünden daha iyi ol." },
  { q: "Devler gibi eserler için...", a: "Karıncalar gibi çalış.", d: "Büyük başarılar, küçük ama sürekli çabaların ürünüdür." },
  { q: "Yapabilirim demek...", a: "Başarmanın yarısıdır.", d: "Kendine inanmak, beynini başarıya kodlamaktır." },
  { q: "Planın yoksa...", a: "Hata yapıyorsundur.", d: "Güne başlarken ne yapacağını bilmek, zamanı yönetmenin anahtarıdır." },
  { q: "Tembellik tatlıdır ama...", a: "Meyvesi acıdır.", d: "Şimdi rahatlamak, ileride zorlanmak demektir. Şimdi zorlan, sonra rahatla." },
  { q: "Bilgi güçtür.", a: "Onu kullan.", d: "Öğrendiklerini sadece sınavda değil, hayatında da kullanmaya çalış." },
  { q: "Kader gayrete aşıktır.", a: "Çabala!", d: "Sen elinden geleni yaparsan, hayat da sana karşılığını verir." },
  { q: "Zirveye giden yol...", a: "Yokuştur.", d: "Yoruluyorsan, doğru yoldasın demektir. Düz yol zirveye çıkarmaz."
  },
  { q: "Bahane üretme.", a: "Çözüm üret.", d: "Başarılı insanlar yol arar, başarısız insanlar bahane arar." },
  { q: "Odaklan!", a: "Dağılma.", d: "Aynı anda iki tavşanı kovalarsan, ikisini de yakalayamazsın. Tek bir işe odaklan." },
  { q: "Okumak...", a: "Zekayı parlatır.", d: "Kitap okumak sadece kelime hazineni değil, anlama kapasiteni de artırır." },
  { q: "Erteleme!", a: "Hemen yap.", d: "En zor iş, başlamaktır. Başladığında yarısının bittiğini göreceksin." },
  { q: "Hayallerin mi büyük?", a: "Korkuların mı?", d: "Korkularının hayallerinin önüne geçmesine izin verme." },
  { q: "Disiplin nedir?", a: "İradeni kullanmaktır.", d: "Canın istemese bile yapman gerekeni yapmak, başarının anahtarıdır." },
  { q: "Şans nedir?", a: "Hazırlık + Fırsat.", d: "Sen hazır olursan, fırsatlar karşına çıktığında şanslı olursun." },
  { q: "Ne ekersen...", a: "Onu biçersin.", d: "Bugün zihnine bilgi ekersen, yarın başarı biçersin." },
  { q: "Denemediğin atışların...", a: "%100'ünü kaçırırsın.", d: "Yapamam deme, dene. Denemek kaybetmek değildir." },
  { q: "Sen bir yıldızsın.", a: "Parla!", d: "İçindeki potansiyeli ortaya çıkar. Kimsenin ışığını söndürmesine izin verme." },
  { q: "Zaman en değerli hazinedir.", a: "Onu iyi kullan.", d: "Geçen bir saniyeyi bile geri alamazsın. Bugününü yarına yatırım yap." },
  { q: "Damlaya damlaya...", a: "Göl olur!", d: "Küçük çalışmalar birikerek büyük başarıları oluşturur. Sabırlı ol." },
  { q: "Karanlığın en koyu anı...", a: "Aydınlığa en yakındır.", d: "Tam vazgeçecekken hatırla: Şafak sökmeden hemen önce karanlık en yoğundur." },
  { q: "Başarı bir varış değil...", a: "Yolculuktur.", d: "Önemli olan sonuç kadar süreçte neler öğrendiğindir." }
];

interface MotivationCard {
  id: string;
  icon: string;
  title: string;
  question: string;
  answer: string;
  label: string;
  gradient: string;
  details: string;
  isInteractive?: boolean;
}

export default function DailyMotivation() {
  const [cards, setCards] = useState<MotivationCard[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    // --- 1. Sol Kart İçin Güvenli Veri Çekme ---
    let randomUnitName = "Fen Bilimleri";
    let randomTopicName = "DNA ve Genetik Kod";
    let randomTopicSummary = "DNA, canlıların genetik bilgilerini taşıyan yapıdır.";

    // Try-Catch benzeri bir mantıkla veriyi kontrol ediyoruz
    if (curriculumData && Array.isArray(curriculumData) && curriculumData.length > 0) {
      const randomUnitIndex = Math.floor(Math.random() * curriculumData.length);
      const randomUnit = curriculumData[randomUnitIndex];
      randomUnitName = randomUnit.name;
      
      if (randomUnit.topics && randomUnit.topics.length > 0) {
        const randomTopicIndex = Math.floor(Math.random() * randomUnit.topics.length);
        const randomTopic = randomUnit.topics[randomTopicIndex];
        randomTopicName = randomTopic.name;
        randomTopicSummary = randomTopic.summary;
      }
    }

    // --- 2. Orta Kart İçin Rastgele Bilim Sorusu (Genişletilmiş Veri) ---
    const randomTriviaIndex = Math.floor(Math.random() * scienceTriviaData.length);
    const randomTrivia = scienceTriviaData[randomTriviaIndex];

    // --- 3. Sağ Kart İçin Motivasyon (Genişletilmiş Veri) ---
    const randomQuoteIndex = Math.floor(Math.random() * motivationData.length);
    const randomQuote = motivationData[randomQuoteIndex];

    // Kartları Oluştur
    const dailyCards: MotivationCard[] = [
      {
        id: 'curriculum',
        icon: 'ri-lightbulb-flash-line',
        title: 'Günün Fen Konusu',
        question: `Biliyor musun: ${randomTopicName}?`,
        answer: randomUnitName,
        label: 'Ünite',
        gradient: 'from-yellow-500 to-orange-500',
        details: randomTopicSummary,
      },
      {
        id: 'trivia',
        icon: 'ri-robot-2-line',
        title: 'Günün Bilim İpucu',
        question: randomTrivia.question,
        answer: randomTrivia.answer,
        label: 'Cevap',
        gradient: 'from-violet-600 to-indigo-600', // Yapay zeka rengi
        details: randomTrivia.detail,
      },
      {
        id: 'motivation',
        icon: 'ri-trophy-line',
        title: 'Günün Motivasyonu',
        question: randomQuote.q,
        answer: randomQuote.a,
        label: 'İpucu',
        gradient: 'from-pink-500 to-rose-500',
        details: randomQuote.d,
      }
    ];

    setCards(dailyCards);
  }, []);

  const handleCardClick = (card: MotivationCard) => {
    if (card.isInteractive) {
      // Ortadaki karta tıklanınca Yapay Zeka sayfasına git
      navigate('/ai-evaluation'); 
    }
  };

  if (cards.length === 0) return null;

  return (
    <div className="w-full">
      {/* BAŞLIK */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal-50 text-teal-600 text-sm font-medium mb-6">
          <i className="ri-magic-line"></i>
          Günlük Motivasyon & Bilgi
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-space">
          Bugün Seni Bekleyen <span className="text-teal-600">İlham</span>
        </h2>
        
        <p className="text-lg text-gray-600 font-poppins max-w-2xl mx-auto">
          Her gün yeni bir bilgi, ilginç bir gerçek ve motivasyon dozu.
        </p>
      </div>

      {/* KARTLAR */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
        {cards.map((card, index) => (
          <div 
            key={index}
            onClick={() => handleCardClick(card)}
            className={`group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-transparent 
              ${card.isInteractive ? 'hover:border-indigo-200 ring-2 ring-transparent hover:ring-indigo-100' : 'hover:border-teal-100'}`}
          >
            <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${card.gradient} mb-4 group-hover:scale-110 transition-transform duration-300`}>
              <i className={`${card.icon} text-3xl text-white`}></i>
            </div>
            
            <h3 className="text-lg font-bold text-gray-900 mb-3 font-space flex items-center gap-2">
              {card.title}
              {card.isInteractive && <span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full">AI</span>}
            </h3>
            
            <p className="text-xl font-semibold text-gray-800 mb-3 font-poppins line-clamp-2 min-h-[3.5rem]">
              {card.question}
            </p>
            
            <div className="pt-3 border-t border-gray-100 mb-3">
              <p className="text-sm text-gray-600 font-poppins">
                <strong className={card.isInteractive ? "text-indigo-600" : "text-teal-600"}>{card.label}:</strong> {card.answer}
              </p>
            </div>

            <div className="flex items-center gap-2 text-sm font-medium mb-4">
              <span className="text-xs text-gray-500 group-hover:text-gray-700 transition-colors line-clamp-3 leading-relaxed">
                {card.details}
              </span>
            </div>
            
            {/* Alt Buton Alanı */}
            <div className={`mt-auto flex items-center text-sm font-bold opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0
              ${card.isInteractive ? 'text-indigo-600' : 'text-teal-600'}`}>
              
              {card.isInteractive ? (
                <>
                  <i className="ri-bard-fill mr-2"></i>
                  <span>Keşfet</span>
                </>
              ) : (
                <span>Keşfet</span>
              )}
              <i className="ri-arrow-right-line ml-1"></i>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}